/* tslint:disable */
/* eslint-disable */
/**
 * PRMGApp
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
export function TimeSpanFromJSON(json) {
    return TimeSpanFromJSONTyped(json, false);
}
export function TimeSpanFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'ticks': !exists(json, 'ticks') ? undefined : json['ticks'],
        'days': !exists(json, 'days') ? undefined : json['days'],
        'hours': !exists(json, 'hours') ? undefined : json['hours'],
        'milliseconds': !exists(json, 'milliseconds') ? undefined : json['milliseconds'],
        'minutes': !exists(json, 'minutes') ? undefined : json['minutes'],
        'seconds': !exists(json, 'seconds') ? undefined : json['seconds'],
        'totalDays': !exists(json, 'totalDays') ? undefined : json['totalDays'],
        'totalHours': !exists(json, 'totalHours') ? undefined : json['totalHours'],
        'totalMilliseconds': !exists(json, 'totalMilliseconds') ? undefined : json['totalMilliseconds'],
        'totalMinutes': !exists(json, 'totalMinutes') ? undefined : json['totalMinutes'],
        'totalSeconds': !exists(json, 'totalSeconds') ? undefined : json['totalSeconds'],
    };
}
export function TimeSpanToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'ticks': value.ticks,
    };
}
